import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import ChequeListView from 'src/sections/cheque/view/cheque-list-view';

export default function ChequeListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Cheque</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_CHEQUE,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <ChequeListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
